import { createApi } from 'ReduxHelpers';
import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { transformResponseWithCurrentUserPushMessages } from 'BackRoyalApi/transformResponseWithCurrentUserPushMessages';
import {
    type CreateProjectGroupParams,
    type CreateProjectGroupResponse,
    type ProjectGroupMemberUserAttrs,
    type ProjectGroupMemberSearchParams,
    type ProjectGroupShowResponse,
} from './ProjectGroup.types';

export const projectGroupsApi = createApi('ProjectGroups', {
    ...getBackRoyalApiBaseConfig('ProjectGroups'),
    endpoints: builder => ({
        create: builder.mutation<CreateProjectGroupResponse, CreateProjectGroupParams>({
            query: params => ({ method: 'post', url: 'project_groups.json', body: params }),
            transformResponse: (response: CreateProjectGroupResponse) => {
                transformResponseWithCurrentUserPushMessages(response.meta.pushMessages);
                return response;
            },
        }),
        memberSearch: builder.query<ProjectGroupMemberUserAttrs, ProjectGroupMemberSearchParams>({
            query: params => ({
                url: 'project_groups/member_search.json',
                method: 'GET',
                params,
            }),
        }),
        getProjectGroup: builder.query<ProjectGroupShowResponse, string>({
            query: id => ({
                url: `project_groups/${id}.json`,
                method: 'GET',
            }),
        }),
    }),
});
